import { addNotification } from './addNotification'

export const addCatchNotification = (error: unknown) => addNotification({ message: error })
